import { useEffect } from "react";
import { FormHelperText } from "@mui/material";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import Select from "@components/Select/Select";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";

const LANG_BASE = "vessel-call.port-services.fields";

const ChargedPartyField = ({ initialValue }: { initialValue?: string }) => {
  const { t } = useTranslation();
  const { chargedParty, setChargedParty, errors, setErrors } = usePortServicesFlow();

  const chargedPartyOptions = [
    { label: t(`${LANG_BASE}.vessel`), value: "VESSEL" },
    { label: t(`${LANG_BASE}.supply-boat`), value: "SUPPLY_BOAT" },
  ];

  useEffect(() => {
    setChargedParty(initialValue ?? "");
  }, [initialValue, setChargedParty]);

  return (
    <div className="flex flex-col gap-2">
      <CustomFormLabel data-testid="ship-chandling-charged-party-label">
        {t(`${LANG_BASE}.charged-party`)}
      </CustomFormLabel>
      <Select
        options={chargedPartyOptions}
        value={chargedParty}
        onChange={(value) => {
          setChargedParty(value);
          setErrors((prev) => ({ ...prev, chargedParty: undefined }));
        }}
        testId="ship-chandling-charged-party-select"
        placeholder={t(`${LANG_BASE}.charged-party`)}
        style={{ width: "100%" }}
      />
      {errors.chargedParty && (
        <FormHelperText sx={{ color: "error.main", m: 0 }}>{errors.chargedParty}</FormHelperText>
      )}
    </div>
  );
};

export default ChargedPartyField;
